export default __webpack_public_path__ + "static/media/graph.12aaad9f.png";